import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { useProductDetailContext, createImpressionEvent, createInteractionEvent } from '@grandvisionhq/products';
import { useIntl } from '@grandvisionhq/state';
import { withLazyLoading, replaceWhitespace } from '@grandvisionhq/utils';
import { useAlgoliaSearch } from '../Algolia/hooks/use-algolia-search.js';
import { AlgoliaCrossSellProducts } from './AlgoliaCrossSellProducts.js';
import { getAlgoliaFilters } from './utils/get-algolia-filters.js';

// This is the REST version of the CrossSellProducts
const CrossSellProducts = ({ algoliaConfig  })=>{
    const { facets  } = algoliaConfig;
    const { activeSku , product: product1 , activeVariant  } = useProductDetailContext();
    const { currency , locale , getLabel  } = useIntl();
    const { filters , optionalFilters  } = React.useMemo(()=>getAlgoliaFilters(product1, facets, activeSku, locale)
    , [
        product1,
        facets,
        activeSku,
        locale
    ]);
    // QueryParameters to be sent to Algolia
    const searchOptions = React.useMemo(()=>{
        const ruleContexts = [
            `cs-${activeSku}`,
            `cs-${replaceWhitespace(activeVariant.brand, '_')}`
        ];
        if (product1.productType.obj && product1.productType.obj.key) {
            ruleContexts.push(`cs-${replaceWhitespace(product1.productType.obj.key, '_').toLowerCase()}`);
        }
        if (CommerceToolsApi.isLenses(activeVariant)) {
            ruleContexts.push(`cs-${replaceWhitespace(activeVariant.lensType, '_')}`);
            activeVariant.replacementFrequency && ruleContexts.push(`cs-${replaceWhitespace(activeVariant.replacementFrequency, '_')}`);
        }
        return {
            filters,
            optionalFilters,
            hitsPerPage: 10,
            ruleContexts
        };
    }, [
        filters,
        optionalFilters,
        product1.productType,
        activeSku,
        activeVariant
    ]);
    const { result , isLoading , hasError  } = useAlgoliaSearch(algoliaConfig, searchOptions);
    const isVisible = result.length > 0 && !isLoading && !hasError;
    const showLoader = result.length === 0 && isLoading;
    const handleImpression = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createImpressionEvent(product, position, 'cross-sell recommendation pdp', currency));
    }, [
        currency
    ]);
    const handleInteraction = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createInteractionEvent(product, position, 'cross-sell recommendation pdp', currency));
    }, [
        currency
    ]);
    return showLoader || isVisible ? /*#__PURE__*/ React.createElement(AlgoliaCrossSellProducts, {
        title: getLabel('products.crossSell.title'),
        result: result,
        isLoading: isLoading,
        handleImpression: handleImpression,
        handleInteraction: handleInteraction
    }) : null;
};
var CrossSellProducts$1 = withLazyLoading(CrossSellProducts);

export { CrossSellProducts, CrossSellProducts$1 as default };
//# sourceMappingURL=CrossSellProducts.js.map
